import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ClientService } from '../../../core/api/client.service';
import { Client } from '../../../core/models/client.model';
import { formatDate, formatDateTime } from '../../../shared/utils/date.utils';
import { CopyTextComponent } from '../../../shared/components/copy-text/copy-text.component';

@Component({
  selector: 'app-client-detail',
  standalone: true,
  imports: [
    CommonModule, RouterModule, MatCardModule, MatIconModule, MatButtonModule,
    MatListModule, MatDividerModule, MatProgressSpinnerModule, MatSnackBarModule,
    CopyTextComponent,
  ],
  templateUrl: './client-detail.component.html',
  styleUrl: './client-detail.component.scss',
})
export class ClientDetailComponent implements OnInit {
  loading = true;
  client: Client | null = null;
  formatDate = formatDate;
  formatDateTime = formatDateTime;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private clientService: ClientService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (!id) {
      this.router.navigate(['/clients']);
      return;
    }
    this.clientService.get(id).subscribe({
      next: (c) => {
        this.client = c;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.snackBar.open('Клиент не найден', 'ОК', { duration: 3000 });
        this.router.navigate(['/clients']);
      },
    });
  }
}
